/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";
import sourceFromPathname from "analytics/util/source";
import formattedCameFromParam from "analytics/util/cameFrom";
import {
	SET_SELECTED_PRODUCT_PACKAGE,
} from "ducks/boosts";
import { getValueForPromoDesign } from "analytics/util/queryParamsMap";
import { getQuery } from "analytics/util/helpers";

// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function boosts(state, action) {
	switch (action.type) {
		case SET_SELECTED_PRODUCT_PACKAGE: {
			const {
				selectedProductPackage,
			} = action.payload;

			const cameFrom = formattedCameFromParam("boost");

			const promoDesignQuery = getQuery("pd");
			const promoDesignEventAttr = promoDesignQuery
				? getValueForPromoDesign(promoDesignQuery)
				: null;

			Analytics.logUIEvent(
				Analytics.eventNames.selectedPackageOnRateCard,
				{
					data: {
						"feature": "boost",
						"feature type": "token",
						"rate card name": state.rateCardName,
						"total token package price": selectedProductPackage.initialPrice / 100,
						"token package": selectedProductPackage.tokensNumber,
						"promo id": cameFrom,
						"came from": cameFrom,
						source: sourceFromPathname(),
						"promo design": promoDesignEventAttr,
					},
				},
			);

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/boosts.js